import { BybConditionalWrapper } from "@Components/common/byb-ds";
import HapticsButtonWrapper from "@Components/generic/haptics-button-wrapper";
import Icon from "@Components/generic/icon";
import TooltipWrapperV2 from "@Components/generic/tooltip-wrapper-v2";
import { Events } from "@Context/common/general/context";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle, faLock } from "@fortawesome/pro-solid-svg-icons";
import { Card, CardActionArea, Stack, Typography, useTheme } from "@mui/material";
import { ColorGradient, NavCardIconWrapper } from "./styled-components";

/**
 * This component is part of the VR app V2 redesign
 */

interface INavCardSmall {
  title: string;
  color: ColorGradient;
  to: string;
  icon?: IconDefinition;
  disabled?: boolean;
  disabledText?: string;
}

const NavCardSmall = ({ title, icon, color, to, disabled = false, disabledText }: INavCardSmall) => {
  const theme = useTheme();

  const handleNavigate = () => {
    Events.app.navigate.emit({ path: to });
  };

  return (
    <Stack sx={{ flexGrow: 1, overflow: "hidden" }}>
      <BybConditionalWrapper
        condition={disabled && !!disabledText}
        trueWrapper={children => (
          <TooltipWrapperV2
            tooltipComponent={
              <Stack direction="row" sx={{ padding: theme.spacing(2) }} alignItems="center" spacing={1}>
                <Icon icon={faInfoCircle} color={theme.palette.dsBase.v100} size="2x" />
                <Typography variant="text1xl500" color="dsBase.v100">
                  {disabledText}
                </Typography>
              </Stack>
            }
          >
            {children}
          </TooltipWrapperV2>
        )}
      >
        <Card>
          <HapticsButtonWrapper>
            <CardActionArea
              onClick={handleNavigate}
              disabled={disabled}
              sx={{ padding: theme.spacing(3), borderRadius: 0 }}
              disableRipple
              disableTouchRipple
            >
              <Stack flexDirection="row" alignItems="center" justifyContent="start">
                {icon && (
                  <NavCardIconWrapper
                    iconbgcolor={disabled ? undefined : color}
                    sx={{ cornerShape: "squircle", borderRadius: "32px", height: 56, width: 56, overflow: "hidden", marginRight: theme.spacing(2.5) }}
                  >
                    <Icon icon={disabled ? faLock : icon} color="#FFF" size="2xl" />
                  </NavCardIconWrapper>
                )}
                <Typography variant="text2xl700" color="dsBase.v200" sx={{ flexGrow: 1 }}>
                  {title}
                </Typography>
              </Stack>
            </CardActionArea>
          </HapticsButtonWrapper>
        </Card>
      </BybConditionalWrapper>
    </Stack>
  );
};

export default NavCardSmall;
